export default {
  cnCode: "Código CN",
  factorValue: "Factor de emisión",
  unit: "Unidad",
  coefficient: "Coeficiente de proceso",
  description: "Descripción",
  createdAt: "Creado el",
  updatedAt: "Actualizado el",
  action: "Acción",
  error: "Error",
  search: "Buscar",
  add: "Agregar factor",
  edit: "Editar",
  template: "Plantilla",
  csvTemplate: "Plantilla CSV",
  xlsxTemplate: "Plantilla XLSX",
  deleteConfirm: "¿Está seguro de que desea eliminar este factor?",
  deleteConfirmBatch: "¿Está seguro de que desea eliminar estos factores?",
  import: "Importar factores",
  export: "Exportar factores",
  close: "Cerrar",
  reset: "Volver a importar",
  resetConfirm: "¿Está seguro de que desea volver a importar?",
  ok: "Aceptar",
  clearInvalid: "Eliminar datos inválidos",
  showErrorRows: "Mostrar datos de error",
  hideErrorRows: "Ocultar datos de error",
  placeholder: {
    cnCode: "Ingrese el código CN (ej. '24')",
    factorValue: "Ingrese el factor de emisión",
    coefficient: "Ingrese el coeficiente de proceso (0-1)",
    description: "Ingrese la descripción (ej. 'Usado para producción de acero de bajo carbono')",
    unit: "Seleccione la unidad",
  },
  cnCodeRequired: "Por favor ingrese el código CN",
  cnCodeMaxLength: "El código CN no puede exceder los 20 caracteres",
  cnCodeFormat: "El código CN solo puede contener letras, números y guiones bajos",
  cnCodeExample:
    "Ejemplo: Código CN de acero '24', factor de emisión 1.5, coeficiente de proceso 0.8",
  factorValueRequired: "Por favor ingrese el factor de emisión",
  factorValueMin: "El factor de emisión debe ser mayor que 0",
  factorValueUnit: "La unidad es kg CO2e/kg, convertir el cemento a esta unidad",
  coefficientRequired: "Por favor ingrese el coeficiente de proceso",
  coefficientRange: "El coeficiente de proceso debe estar entre 0 y 1",
  descriptionMaxLength: "La descripción no puede exceder los 255 caracteres",
  fetchError: "Error al obtener los factores",
  addSuccess: "Factor agregado con éxito",
  addError: "Error al agregar el factor",
  editSuccess: "Factor actualizado con éxito",
  editError: "Error al actualizar el factor",
  deleteSuccess: "Factor eliminado con éxito",
  deleteError: "Error al eliminar el factor",
  exportSuccess: "Exportación exitosa",
  exportError: "Error al exportar los factores",
  uploadFormatError: "Solo se admiten archivos CSV o XLSX",
  headerInvalid:
    "Encabezado de archivo inválido, esperado: cn_code,factor_value,coefficient,description",
  headerSkipped: "Fila de encabezado omitida",
  importLimitExceeded: "Los datos de importación exceden el límite (máx. {max} filas válidas)",
  noValidData: "No hay datos de factores válidos",
  parseError: "Error al analizar el archivo",
  importError: "Error al importar los factores",
  importSuccess: "{count} factores importados con éxito",
  clearInvalidSuccess: "{count} filas de datos inválidos eliminadas",
  noInvalidData: "No hay datos inválidos para eliminar",
  uploadText: "Haga clic o arrastre el archivo a esta área para cargarlo",
  uploadHint: "Admite formatos CSV y XLSX",
  unitRequired: "Por favor seleccione una unidad",
  unitInvalid: "Unidad inválida, solo se admiten kg CO2e/kg o kg CO2e/tonelada",
  batchDelete: "Eliminación por lotes",
  batchDeleteSuccess: "{count} factores eliminados con éxito",
  batchDeleteError: "Error al eliminar factores por lotes",
};
